var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sellPricingDetails" },
    [
      _c("van-nav-bar", {
        attrs: {
          "left-arrow": "",
          fixed: "",
          border: false,
          "safe-area-inset-top": "",
          placeholder: "",
          title: "定价详情"
        },
        on: { "click-left": _vm.leftClick }
      }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "flex topInfo color1a" }, [
            _c("h3", [_vm._v("订单信息")]),
            _c(
              "h3",
              {
                style: {
                  color:
                    _vm.sellPricingData.status == "UNDELIVERED"
                      ? "#ffb200"
                      : _vm.sellPricingData.status == "DONE"
                      ? "#999999"
                      : "#1a1a1a"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.sellPricingData.status == "SUSPENSE"
                      ? "待审核"
                      : _vm.sellPricingData.status == "DONE"
                      ? "已完成"
                      : _vm.sellPricingData.status == "UNDELIVERED"
                      ? "待送货"
                      : _vm.sellPricingData.status == "FAIL"
                      ? "拒绝交易"
                      : "已取消"
                  )
                )
              ]
            ),
            _c("div", { staticClass: "iconMai" }, [_vm._v("卖")])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("下单时间 :")]),
            _c("div", [
              _vm._v(
                _vm._s(_vm._f("formatDate_")(_vm.sellPricingData.createTime))
              )
            ])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("订单编号 :")]),
            _c("div", [_vm._v(_vm._s(_vm.sellPricingData.oid))])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("货物类别 :")]),
            _c("div", [_vm._v(_vm._s(_vm.sellPricingData.goods[0].name))])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("定价重量(元/克) :")]),
            _c("div", { staticClass: "color6" }, [
              _vm._v(_vm._s(_vm.sellPricingData.goods[0].weight.toFixed(2)))
            ])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("定价单价(元/克) :")]),
            _c("div", { staticClass: "color6" }, [
              _vm._v(_vm._s(_vm.sellPricingData.goods[0].price))
            ])
          ]),
          _c("div", { staticClass: "flex btmInfo color9" }, [
            _c("div", { staticClass: "time" }, [_vm._v("订单金额(元) :")]),
            _c("div", { staticClass: "color6" }, [
              _vm._v(_vm._s(_vm.sellPricingData.goods[0].total.toFixed(2)))
            ])
          ]),
          _c("div", { staticClass: "flex btmInfo color9 " }, [
            _c("div", { staticClass: "time" }, [_vm._v("未交料重量 :")]),
            _c(
              "div",
              {
                staticClass: "color9",
                style: {
                  color:
                    _vm.sellPricingData.status == "DONE"
                      ? "#999999"
                      : _vm.sellPricingData.status == "FAIL"
                      ? "#999999"
                      : "#ffb200"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.sellPricingData.hasOwnProperty("freeWeight")
                      ? _vm.sellPricingData.freeWeight.toFixed(2)
                      : "0.00"
                  )
                )
              ]
            )
          ]),
          _vm._l(_vm.sellPricingData.referenceInfoList, function(item) {
            return _c("div", { key: item.openId }, [
              (_vm.sellPricingData.status == "UNDELIVERED"
              ? true
              : _vm.sellPricingData.status == "DONE"
              ? true
              : false)
                ? _c("div", { staticClass: "btmBorder" }, [
                    _c("div", { staticClass: "flex btmInfo color9" }, [
                      _c("div", { staticClass: "time" }, [
                        _vm._v("结算时间 :")
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("formatDate_")(item.time)))
                      ])
                    ]),
                    _c("div", { staticClass: "flex btmInfo color9 " }, [
                      _c("div", { staticClass: "time" }, [
                        _vm._v("结算重量(g)")
                      ]),
                      _c("div", [_vm._v(_vm._s(item.referenceWeight))])
                    ]),
                    _c("div", { staticClass: "flex btmInfo color9 " }, [
                      _c("div", { staticClass: "time" }),
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.orderJieSuan(item)
                            }
                          }
                        },
                        [_vm._v("详情 >")]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }